import { ApiParameter, get, post, ServiceResult } from "@insite/client-framework/Services/ApiService";

const apiUri = "/api/v2/dana";
export interface ValidateApiParameter extends ApiParameter {
    registeredCustomerNumber?: string,
    email?:string;
    phone?:string;
    success?:boolean
}

export async function getValidateCustomerNumber(parameter: ValidateApiParameter): Promise<ServiceResult<boolean>> {
    try {      
        const accountModel = await get<ValidateApiParameter>(`${apiUri}/ValidateCustomerNumber?request=${Math.random()}`, parameter,{},"no-cache");
        return {   
            result:accountModel?.success as boolean,
            successful: true,
        };
    } catch (error) {
        if ("status" in error && error.status === 400 && error.errorJson && error.errorJson.message) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        } if("status" in error && error.status === 404 && error.errorJson && error.errorJson.message) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}
export async function getUserAlreadyExist(parameter: ValidateApiParameter): Promise<ServiceResult<boolean>> {
    try {      
        const accountModel = await get<ValidateApiParameter>(`${apiUri}/IsUserAlreadyExist?request=${Math.random()}`, parameter,{},"no-cache");
        return {   
            result:accountModel?.success as boolean,
            successful: true,
        };
    } catch (error) {
        if ("status" in error && error.status === 400 && error.errorJson && error.errorJson.message) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        } if("status" in error && error.status === 404 && error.errorJson && error.errorJson.message) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}
export async function validateForgotPasswordEmail(parameter: ValidateApiParameter): Promise<ServiceResult<boolean>> {
    try {      
        const accountModel = await get<ValidateApiParameter>(`${apiUri}/ForgotPasswordEmailValidation?request=${Math.random()}`, parameter,{},"no-cache");
        return {   
            result:accountModel?.success as boolean,
            successful: true,
        };
    } catch (error) {
        if ("status" in error && error.status === 400 && error.errorJson && error.errorJson.message) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        } if("status" in error && error.status === 404 && error.errorJson && error.errorJson.message) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}

export async function getValidatePhone(parameter: ValidateApiParameter): Promise<ServiceResult<boolean>> {
    try {      
        const accountModel = await get<ValidateApiParameter>(`${apiUri}/ValidatePhoneNumber?request=${Math.random()}`, parameter,{},"no-cache");
        return {   
            result:accountModel?.success as boolean,
            successful: true,
        };
    } catch (error) {
        if ("status" in error && error.status === 400 && error.errorJson && error.errorJson.message) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        } if("status" in error && error.status === 404 && error.errorJson && error.errorJson.message) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}
